import { ReactNode } from 'react';
import useAuthLayoutStyles from './authLayout.styles';
import DecorativePattern from './components/DecorativePattern/DecorativePattern';

interface AuthLayoutSlots {
  footer?: ReactNode;
}

interface AuthLayoutProps {
  imageUrl?: string;
  children: ReactNode;
  slots?: AuthLayoutSlots;
}

const AuthLayout = ({ imageUrl, children, slots }: AuthLayoutProps) => {
  const { classes } = useAuthLayoutStyles({ hasImage: !!imageUrl });

  return (
    <div className={classes.root}>
      <div className={classes.visualPanel}>
        {imageUrl ? (
          <img src={imageUrl} alt="" className={classes.visualImage} />
        ) : (
          <DecorativePattern />
        )}
      </div>
      <div className={classes.contentPanel}>
        {children}
        {slots?.footer && <div className={classes.footerSlot}>{slots.footer}</div>}
      </div>
    </div>
  );
};

export default AuthLayout;
